/**
 * Shared DOMPurify wrapper for safe HTML rendering.
 *
 * We render server-rendered markdown HTML (Python `markdown` lib) inside
 * `dangerouslySetInnerHTML` in two spots:
 *   - public blog/updates page (UpdatePostPage)
 *   - admin markdown preview (AdminPostEditor)
 *
 * Both inputs are technically trusted (admin-curated content), but defense
 * in depth — if a stored XSS payload ever sneaks in, DOMPurify strips it.
 */
import DOMPurify from "dompurify";

// Allow a small, blog-friendly subset of HTML tags + standard attrs.
// `class` is allowed so syntax-highlighted code blocks survive.
const CONFIG = {
    ALLOWED_TAGS: [
        "a", "p", "br", "strong", "em", "u", "s", "code", "pre",
        "h1", "h2", "h3", "h4", "h5", "h6",
        "ul", "ol", "li",
        "blockquote", "hr",
        "img", "figure", "figcaption",
        "table", "thead", "tbody", "tr", "th", "td",
        "span", "div",
    ],
    ALLOWED_ATTR: ["href", "title", "alt", "src", "class", "id", "target", "rel", "style"],
    // Allow only http(s) / mailto / relative URLs.
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
};

export function sanitizeHtml(html) {
    if (!html) return "";
    return DOMPurify.sanitize(html, CONFIG);
}
